// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0175d656","667":"f326b569","977":"55e6fedb"}[chunkId] + ".chunk.js";
};